import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HierarchyNodeLevelResponseDto } from './hierarchy-node-level.model';
import { HierarchyType } from '../hierarchy-type.enum';

@Injectable({
    providedIn: 'root'
})
export class HierarchyNodeLevelService {
	private httpClient = inject(HttpClient);


	list(subscriberKey: number, hierarchyType?: HierarchyType) {
        const params = hierarchyType === undefined
            ? undefined
            : {hierarchyType};

		return this.httpClient.get<HierarchyNodeLevelResponseDto[]>(`api/subscriber/${subscriberKey}/hierarchy-node-levels`, {params: params});
	}
}
